const mintA = {
  mintA1: "hsla(0, 0%, 0%, 0)",
  mintA2: "hsla(180, 100%, 49.2%, 0.031)",
  mintA3: "hsla(176, 100%, 49.7%, 0.070)",
  mintA4: "hsla(173, 100%, 49.7%, 0.105)",
  mintA5: "hsla(173, 100%, 49.8%, 0.144)",
  mintA6: "hsla(172, 100%, 49.8%, 0.192)",
  mintA7: "hsla(171, 100%, 49.9%, 0.266)",
  mintA8: "hsla(169, 100%, 49.9%, 0.366)",
  mintA9: "hsla(167, 99.8%, 75.0%, 0.870)",
  mintA10: "hsla(163, 99.9%, 80.7%, 0.948)",
  mintA11: "hsla(167, 99.9%, 58.7%, 0.796)",
  mintA12: "hsla(169, 100%, 96.2%, 0.980)"
};
export { mintA };
//# sourceMappingURL=mintA.mjs.map
